import { oz } from '@weft/utils';

export const CREDIT_LEDGER_ENTRY_TYPE = Object.freeze({
  Grant: 'Grant',
  Deduct: 'Deduct',
});

export const CreditLedgerEntryTypeSchema = oz.nativeEnum(CREDIT_LEDGER_ENTRY_TYPE).openapi('BillingCycleStatus');

export type CreditLedgerEntryType = oz.infer<typeof CreditLedgerEntryTypeSchema>;